import {
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { AfterViewInit, Component, OnChanges, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { CURRENT_PAGE, SHOW_TOTAL_PAGES } from '../../../models/Constants';
import { InteractionHistoryService } from 'src/app/services/interaction-history.service';
import { BatchAlertService } from 'src/app/services/batch-alert.service';
import { MultipleAccountService } from 'src/app/services/multiple-account.service';

@Component({
  selector: 'app-alight-table',
  templateUrl: './alight-table.component.html',
  styleUrls: ['./alight-table.component.scss'],
})
export class AlightTableComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() gridColumns: any = [];
  displayedColumns: string[] = [];
  @Input() dataSource = new MatTableDataSource([]);
  @Input() rowPerPage: number = 10;
  @Input() totalRecords: number = -1;
  @Input() disableButtons: boolean = false;
  @Input() hideReplaceAddButton: boolean = false;
  @Input() isShowButtons: boolean = true;
  @Input() isPagination: boolean = true;
  @Input() tableName: any;
  @Input() sortRequired: boolean = true;
  @ViewChild(MatTable, { read: ElementRef }) private matTableRef!: ElementRef;
  @Input() selectedRow: any;
  @Input() IHListViewLoader: boolean = false;

  @Input() GoToCustomerAcc: boolean = true;
  @Output() rowSelection: EventEmitter<any> = new EventEmitter();
  columns: any[] = [];
  totalPage: number = 0;
  pageNumbers: any[] = [];
  enumButton = Constants.buttonEnum;
  pressed = false;
  currentResizeIndex: number = 0;
  startX: number = 0;
  startWidth: number = 0;
  isResizingRight: boolean = true;
  isPreviousDisabled: boolean = true;
  isNextDisabled: boolean = true;
  public totalCount: string = Constants.DefaultTableRange;
  noRecordFoundMsg: any = Constants.NO_RESULT_DISPLAY_MSG;  // create to show no record message inside table
  resizableMousemove!: () => void;
  resizableMouseup!: () => void;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    public renderer: Renderer2,
    public rootScope: RootScopeService,
    public initHistService: InteractionHistoryService,
    public batchAlertService: BatchAlertService, public multiAccountService:MultipleAccountService

  ) { }
  public rowData: any;
  ngOnInit() {
    this.rootScope.agenIneractionData.isAgentClientAccess = true
    // console.log("aligh table ngOnit called")
    this.rootScope.isGenesysLoggedIn = this.rootScope.checkCallOrChat() ? this.rootScope.getValueFromSessiondb('connectToGenesys', false) : this.rootScope.isGenesysLoggedIn;
    this.displayedColumns = this.gridColumns.map((x) => x.field);
    this.columns = this.gridColumns.map((str) => ({
      field: str.field,
      width: str.width,
      header: str.header,
    }));
    /* istanbul ignore next */
    this.setDisplayedColumns();
    if (this.tableName == "currentTable" || this.tableName == "deleteTable" || this.tableName == "ArchivedTable"){
        /* istanbul ignore next */
      this.setGridSortAndPagination();
    }
    // this.noRecord()  
  }

  /**
   * Method to show no record mesaage inside the table 
   * @author :Amarjeet
   */
  noRecord() {
    if (!this.IHListViewLoader) {

      if (this.tableName == 'IHListView') {
        if (this.rootScope.IHListCount > 0 || this.initHistService?.IHListViewDataCAMap?.[this.rootScope.activeCustTab?.customerSessionId]?.isFilterApplied)
          this.noRecordFoundMsg = Constants.NO_RESULT_FILTTER;
        else
          this.noRecordFoundMsg = Constants.USE_FILTER_MSG;//CCR1-2071

      } else if (this.tableName == 'AgentIHView') {
        if (this.rootScope.isAgentFilterApplied)
          this.noRecordFoundMsg = Constants.NO_RESULT_FILTTER;
        else
          this.noRecordFoundMsg = Constants.NO_AGENT_INTERACTION_MSG;
      }
      return this.totalCount;
    }
    return false;
  }

  ngAfterViewInit() {
    // console.log("alightable ngAfterViewInit called")
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }

  ngOnChanges() {
    if (this.tableName == 'IHListView' && this.sort)
      this.setGridSortAndPagination();
    if (this.tableName == 'AgentIHView') {
      this.setGridSortAndPagination();
    }
    else if(this.tableName == 'currentTable'){
      this.setGridSortAndPagination();
    }else if(this.tableName == 'ArchivedTable'){
      this.setGridSortAndPagination();
    }else if(this.tableName == 'deleteTable'){
      this.setGridSortAndPagination();
    }

  }

  createButtons() {
    this.pageNumbers = [];
    for (let i = 1; i <= this.totalPage; i++) {
      if ((i <= SHOW_TOTAL_PAGES && CURRENT_PAGE < SHOW_TOTAL_PAGES)) {
        this.pageNumbers.push(i);
        //  console.log("createButtons" + this.pageNumbers);
      }
    }
  }
  updateGotoNext() {
    let currentPage = this.paginator.pageIndex;
    if (currentPage % 5 == 0) {
      let divisor = Math.floor(currentPage / 5);
      let startPageSize = 5 * divisor + 1;
      this.pageNumbers = [];
      this.sortChange(this.paginator.pageIndex);
      for (let i = startPageSize; i < startPageSize + 5 && i <= this.totalPage; i++) {
        this.pageNumbers.push(i);
      }
    }
  }

  goToFirstPage() {
    let currentPage = this.paginator.pageIndex;
    if (currentPage % 5 == 0) {
      let divisor = Math.floor(currentPage / 5);
      let startPageSize = 5 * divisor + 1;
      this.pageNumbers = [];
      for (let i = startPageSize; i < startPageSize + 5 && i <= this.totalPage; i++) {
        this.pageNumbers.push(i);
      }
    }
  }
  updateGotoLastPage() {
    this.pageNumbers = [];
    for (let i = this.totalPage; i > 0; i--) {
      if (i % SHOW_TOTAL_PAGES == 0 && this.pageNumbers.length != 0) {
        break;
      }
      this.pageNumbers.unshift(i)
    }
  }
  updateGotoPrevious() {
    let currentPage = this.paginator.pageIndex + 1;
    if (currentPage % 5 == 1) {
      let divisor = Math.floor(currentPage / 5);
      let startPageSize = 5 * divisor;
      this.pageNumbers = [];
      let c = startPageSize - 4;
      for (let i = startPageSize; i > startPageSize - 5; i--) {
        this.pageNumbers.push(c++);
      }
    }
  }

  setTableResize(tableWidth: number) {
    let totWidth = 0;
    this.columns.forEach((column) => {
      totWidth += column.width;
    });
    const scale = (tableWidth - 5) / totWidth;
    this.columns.forEach((column) => {
      column.width *= scale;
      this.setColumnWidth(column);
    });
  }

  setDisplayedColumns() {
    this.columns.forEach((column, index) => {
      column.index = index;
      this.displayedColumns[index] = column.field;
    });
  }

  onResizeColumn(event: any, index: number) {
    event.stopPropagation();
    this.checkResizing(event, index);
    this.currentResizeIndex = index;
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = event.target?.parentElement?.clientWidth;
    event.preventDefault();
    this.mouseMove(index);
  }


  /* istanbul ignore next */
  private checkResizing(event, index) {
    const cellData = this.getCellData(index);
    if (
      index === 0 ||
      (event &&
        cellData &&
        Math.abs(event.pageX - cellData.right) < cellData.width / 2 &&
        index !== this.columns.length - 1)
    ) {
      this.isResizingRight = true;
    } else {
      this.isResizingRight = false;
    }
  }

  private getCellData(index: number) {
    const headerRow =
      this.matTableRef.nativeElement.children[0].querySelector('tr');
    const cell = headerRow.children[index];
    return cell?.getBoundingClientRect();
  }

  mouseMove(index: number) {
    this.resizableMousemove = this.renderer.listen(
      'document',
      'mousemove',
      (event) => {
        if (this.pressed && event.buttons) {
          const dx = this.isResizingRight
            ? event.pageX - this.startX
            : -event.pageX + this.startX;
          const width = this.startWidth + dx;
          if (this.currentResizeIndex === index && width > 50) {
            this.setColumnWidthChanges(index, width);
          }
        }
      }
    );
    this.resizableMouseup = this.renderer.listen(
      'document',
      'mouseup',
      (event) => {
         /* istanbul ignore next */
        if (this.pressed) {
          this.pressed = false;
          this.currentResizeIndex = -1;
          this.resizableMousemove();
          this.resizableMouseup();
        }
      }
    );
  }

  setColumnWidthChanges(index: number, width: number) {
    const orgWidth = this.columns[index]?.width;
    const dx = width - orgWidth;
    if (dx !== 0 && orgWidth) {
      const j = this.isResizingRight ? index + 1 : index - 1;
      const newWidth = this.columns[j].width - dx;
      if (newWidth > 50) {
        this.columns[index].width = width;
        this.setColumnWidth(this.columns[index]);
        this.columns[j].width = newWidth;
        this.setColumnWidth(this.columns[j]);
      }
    }
    this.setResizeHeight();
  }

  columnHeaderCls(column, header?) {
    return {
      'resize-handle':
        column.header === 'Last Name' || column.header === 'First Name',
    };
  }

  checkLiveCallorChat() {
    // console.log("selectedRow", this.selectedRow)
    return this.rootScope.activeChatOrCall();
  }

  enableDisableGoToCustAcc() {
    // console.log("Method hideReplaceAddButton called ", this.hideReplaceAddButton)

    if (this.hideReplaceAddButton) {
      /**Case of Duplicate CS Tab */
      if (this.checkLiveCallorChat() && this.selectedRow && (this.rootScope.activeCustTab.activeChat || this.rootScope.activeCustTab.activeCall)) {
        return false;
      }
      else {
        return true;
      }
    }

    else if (!this.checkLiveCallorChat() && this.selectedRow && !this.rootScope.holdLiveDetails[0]?.id) {
      return false;
    }
    else {
      return true;
    }
  }

  checkForAdditonalbtn() {
  //   if(this.rootScope.isLiveChat){
  //     this.rootScope.authorizedRoleType = this.rootScope.customerTabs.some(x => (x.clientId == this.rootScope.activeCustTab.clientId) &&  
  //                                                       (!x?.activeCall || x?.activeChat) && !x?.additionalAccount &&
  //                                                       this.rootScope?.authorized_roletype?.includes(x?.defaultRole))
  //   }
  //   else {
  //     this.rootScope.authorizedRoleType = this.rootScope.customerTabs.some(x =>
  //     (x?.activeCall || x?.activeChat) &&
  //     !x?.additionalAccount &&
  //     this.rootScope?.authorized_roletype?.includes(x?.defaultRole)
  //   );
  // }
   
    if (!this.disableButtons && this.rootScope.fullySecuredCall() && this.rootScope.checkForUnsecuredChat()
      && (this.rootScope.isGenesysLoggedIn || this.rootScope.simulationData.isSimulationModeActive) && this.selectedRow) {
      return false;
    }
    else {
      return true;
    }
    
}

  /**
   *  Update the method for Story CCR1-13249  for Enabling Replace button for SL2 security level.
   *  Enable Replace when an active call/chat tab has SL1 or SL2 security and no multiple/additional account is present.
   */
    checkForReplaceBtn() {
    return (
      this.checkLiveCallorChat() &&
      this.rootScope.customerTabs.find((x) => (x?.CS_SECURITY_LEVEL == Constants.securityLevels.SL1 || x?.CS_SECURITY_LEVEL == Constants.securityLevels.SL2) && (x?.activeCall || x?.activeChat) && !x.isMultipleAccountTabOpened) &&
      !this.rootScope.customerTabs.find((x) => x?.additionalAccount)
    );
  }

  setColumnWidth(column: any) {
    const columnEls = Array.from(
      document.getElementsByClassName('mat-column-' + column?.field)
    );
    columnEls.forEach((el: any) => {
      el.style.width = column?.width + 'px';
    });
  }

  setResizeHeight(zero?) {
    const height = zero ? 0 : this.matTableRef.nativeElement.offsetHeight + 2;
    const headers = Array.from(
      this.matTableRef.nativeElement.children[0].querySelectorAll(
        'span.resize-handle'
      )
    );
    headers.forEach((el: any) => {
      el.style.height = height + 'px';
    });
  }

  /*row selection   */
  rowSelectionCheck(btn, tableName?) {
    if (tableName == 'IHBriefView' || tableName == 'IHListView')
      return false;
    return (!btn && (this.disableButtons)) || this.disableDoubleClickOnUnknownCaller();
  }



  //Redirect and get current row details
  // CCR1-3138
  onRowSingleClick(row, buttonName?, clickType?: any, tableName?: string) {
    this.rootScope.agenIneractionData.isAgentClientAccess = true;
    if (clickType?.type == 'click' && tableName == 'IHListView') {
      this.onRowDoubleClick(row, buttonName, tableName);
    }

    if (clickType?.type == 'click' && tableName == 'currentTable') {
      this.rowSelection.emit({
        row: row
      });
    }
    if(clickType?.type == 'click' && tableName == 'simulationTable'){
      this.rowSelection.emit({
        row: row,
        activateBtn: true
      });
    }

  }
  // CCR1-3138
  onCustomerRowClick(row, buttonName?, clickType?: any, tableName?: string) {
    if (clickType?.type == 'dblclick') {
      this.onRowDoubleClick(row, buttonName, tableName);

    }

  }

  onRowDoubleClick(row, buttonName?, tableName?: string) {

    if (this.rowSelectionCheck(buttonName, tableName)) {
      return;
    }
    else {
      this.rowSelection.emit({
        row: row,
        buttonName: this.defaultBtnName(buttonName),
      });
    }


  }
  onTableRowEnter(row, buttonName?) {
    if (this.rowSelectionCheck(buttonName)) {
      return;
    }
    else {
      this.rowSelection.emit({
        row: row,
        buttonName: this.defaultBtnName(buttonName),
      });
    }
  }
  defaultBtnName(btn) {
    return btn
      ? btn
      : this.checkLiveCallorChat() && !this.hideReplaceAddButton
        ? (this.checkForReplaceBtn() ? this.enumButton.replaceAccount : this.enumButton.additionalAccount)
        : this.enumButton.customerAccount;
  }


  tableFocusout() {
    this.selectedRow = null;
    this.batchAlertService.currentBatchSelectedRow = null;
  }
  ///sorting and pagination
  getTablePageRange(self) {
    setTimeout(() => {
      self.isNextDisabled = !self.paginator.hasNextPage();
      self.isPreviousDisabled = !self.paginator.hasPreviousPage();

      let page = self.paginator.pageIndex,
        pagesize = self.paginator.pageSize,
        length = self.paginator.length;
      self.totalCount = self.paginator._intl.getRangeLabel(
        page,
        pagesize,
        length
      );

      this.setResizeHeight();
    }, 0);
  }

  previousAndNext(next: boolean) {
    this.getTablePageRange(this);
    if (next) {
      this.paginator.nextPage();
      this.updateGotoNext();
    }
    else {
      this.updateGotoPrevious();
      this.paginator.previousPage();
    }
  }

  gotToFirstAndLastPage(isGoToFirstPage: boolean) {
    this.getTablePageRange(this);
    if (isGoToFirstPage) {
      this.paginator.firstPage();
      this.goToFirstPage();
    }
    else {
      this.updateGotoLastPage();
      this.paginator.lastPage();
    }
  }

  goToPageChange(indexNumber: any) {
    this.paginator.pageIndex = indexNumber - 1;
    this.sortChange(this.paginator.pageIndex);
    this.selectedRow = null;
    this.batchAlertService.currentBatchSelectedRow = null;
  }

  pageNumber(event: any) {
    if (
      event &&
      event.keyCode >= 49 &&
      event.keyCode <= this.getCharCode(this.totalPage)
    )
      this.paginator.pageIndex = parseInt(event.key) - 1;
    else
      this.paginator.pageIndex =
        event.keyCode > this.getCharCode(this.totalPage)
          ? this.totalPage - 1
          : 0;
    this.sortChange(this.paginator.pageIndex);

    this.selectedRow = null;
    if (this.paginator.pageIndex == 0 && event.target) event.target.value = 1;
  }

  /**
   * Update method for CCR1-12555 - to handle roleType and channelIcon column title display in table
   */
  getTitle(row, column) {
    switch (column?.field) {
      case 'channelIcon': return row?.['title'];
      case 'roleType': return this.rootScope.getRoleTypeDisplayName(row?.roleType);
      default: return row?.[column?.field];
    }
  }



  sortChange(index?: any) {
    this.paginator.pageIndex = index ? index : 0;
    /* istanbul ignore next */
    this.dataSource.sortingDataAccessor = (
      data: any,
      sortHeaderId: string
    ): string => {
      if (sortHeaderId == 'channelIcon') {
        return data['title'].toLocaleLowerCase();;
      }
      if (sortHeaderId === 'date' && data[sortHeaderId]) {
        return new Date(data[sortHeaderId]).toLocaleDateString();
      }
      if (sortHeaderId === 'startDate' && data[sortHeaderId]) {
        return new Date(data[sortHeaderId]).toLocaleDateString();
      }
      if (sortHeaderId === 'endDate' && data[sortHeaderId]) {
        return new Date(data[sortHeaderId]).toLocaleDateString();
      }

      else if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }


      return data[sortHeaderId];
    };
    if (this.pageNumbers[0] == 6) {
      this.createButtons();
    }

    this.getTablePageRange(this);
    this.paginator._changePageSize(this.paginator.pageSize);
  }

  setGridSortAndPagination() {
    if (this.sort) {
      this.sort['disableClear'] = true;
      this.sort.active = '';
      this.sort.sort({ id: 'lastName', start: 'asc' } as MatSortable);

      this.dataSource.sort = this.sort;
    }
    this.dataSource.paginator = this.paginator;
    this.getTablePageRange(this);
    setTimeout(() => {
      this.totalPage = Math.ceil(
        this.paginator.length / this.paginator.pageSize
      );
      this.setResizeHeight();
      this.createButtons();
    }, 1);
  }

  //get charCode
  getCharCode(data) {
    return data?.toString().charCodeAt();
  }
  //clear all the table data and navigation
  clearAll() {
    this.isNextDisabled = true;
    this.dataSource = new MatTableDataSource([]);
    this.isPreviousDisabled = true;
    this.setResizeHeight(true);
  }

  //check table having data is availble or not
  tableData() {
    return this.dataSource.data && this.dataSource.data.length > 0;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }

  /**
   *  CCR1-7871 
   * Below method created to restrict the double click to open the Customer Account
   *  from Unknown caller page  when Call gets disconnected.
   * @returns boolean 
   * @author - Sultan Khan
   * 
   */

  disableDoubleClickOnUnknownCaller(): boolean {
    return !!(
      this.rootScope.activeCustTab.customerSessionId &&
      this.rootScope.activeCustTab.CS_SECURITY_LEVEL == '0' &&
      this.rootScope.activeCustTab.activeCall == false &&
      this.rootScope.activeCustTab.activeChat == false &&
      this.rootScope.activeCustTab.id == 1
    );
  }
  
  

 
}
